import { Outlet, useOutletContext } from "react-router";

import { Stack } from "@mui/material";
import { ClientFileProvider } from "@shared";

import { ClientDetailResponse } from "@/api";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import { ClientTab, DebtSettlementSubTab, clientPath } from "@/router/ClientRoutes";

export function DebtSettlementTab() {
  const client = useOutletContext<ClientDetailResponse>();
  const { hasPermission } = useCurrentUserContext();

  return (
    <ClientFileProvider
      value={{
        clientId: client.clientId,
        basePaths: {
          assetInventory: clientPath.byDebtSettlementTab({
            id: client.clientId,
            tab: DebtSettlementSubTab.AssetInventory,
          }),
          claims: clientPath.byDebtSettlementTab({ id: client.clientId, tab: DebtSettlementSubTab.Claims }),
          bankruptcyChecklist: clientPath.byDebtSettlementTab({
            id: client.clientId,
            tab: DebtSettlementSubTab.BankruptcyChecklist,
          }),
          clientNote: clientPath.byTab({ id: client.clientId, tab: ClientTab.ClientNote }),
        },
        capabilities: {
          manageGlobalParticipants: hasPermission(UserPermission.Supervisor),
          markBankStatementsRead: true,
          counselorIncomeHelpers: true,
          counselorExpensePartner: true,
        },
      }}
    >
      <Stack flex={1} overflow={"hidden"}>
        <Outlet context={client} />
      </Stack>
    </ClientFileProvider>
  );
}
